<template>
  <v-card
    style="height: 100%"
    :style="salePage ? 'cursor: pointer' : ''"
    @click="salePage ? $emit('onSelectedProductSalePage') : null"
  >
    <div class="card-body">
      <v-responsive :aspect-ratio="1" style="border-radius: 10px 10px 0px 0px;">
        <div
          style="
            background-color: #eee;
            height: 100%;
            position: relative
            
          "
        >
          <v-checkbox
            class="pro"
            :input-value="isCheck"
            size="small"
            style="display: inline-block; margin: 3px 13px; position: absolute; z-index: 2"
            @change="assignCb(product.id)"
            color="#fff"
            v-if="!isKetShop"
          ></v-checkbox>
          <v-layout
            style="position: absolute; width: 100%; z-index: 2; top: 28px"
            v-if="!isKetShop"
          >
            <v-flex>
              <modal-share-link
                v-if="!salePage && productBy !== 'lineMyShop'"
                :productid="product.id"
                :pageid="
                  selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid
                "
              ></modal-share-link>
            </v-flex>
            <v-flex class="text-xs-right">
              <div
                class="text-xs-center sale-tag mr-2 white--text pa-2"
                style="display: inline-block; background: red; color: white; margin: auto"
                v-if="discountPercentage > 0"
              >
                {{ $t('Sale') }}
                <br />
                {{ discountPercentage | numberFormat }}%
              </div>
            </v-flex>
          </v-layout>

          <v-img
            v-if="productImages && productImages.length > 0"
            :src="productImages[0]"
            lazy
            aspect-ratio="1"
            :lazy-src="'/static/img/assets/_global/default-photo.png'"
          >
          </v-img>
          <v-img aspect-ratio="1" v-else :src="'/static/img/assets/_global/default-photo.png'">
          </v-img>
        </div>
      </v-responsive>

      <div style="position: relative">
        <div
          class="action"
          style="position: absolute; top: -20px; left: 0; right: 0px"
          v-if="!salePage"
        >
          <v-layout>
            <v-flex class="px-2">
              <toggle-button
                v-if="productBy !== 'lineMyShop' && !isKetShop"
                class="mt-2"
                :value="product.status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleProductStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                :style="
                  (selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret) ||
                  productBy === 'lineMyShop'
                    ? 'pointer-events: none'
                    : ''
                "
              />
            </v-flex>
            <v-flex
              class="text-xs-right px-2"
              v-if="
                productBy !== 'lineMyShop' &&
                  (!product.ref_code || (product.ref_code && !product.ref_code.includes('ZORTOUT')))
              "
            >
              <v-tooltip
                top
                v-if="
                  $store.getters.getPackage != 'premium' &&
                    indexProduct >= getPackageConfig().products
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn class="extra-small ma-1" readonly fab small color="grey" v-on="on">
                    <v-icon>lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Upgrade to {package} Plan', { package: 'PREMIUM' }) }}</span>
              </v-tooltip>
              <template v-else>
                <v-btn
                  fab
                  depressed
                  color="primary"
                  small
                  class="extra-small ma-1"
                  @click="$emit('onSelectedProduct')"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )
                  "
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>

              <v-btn
                fab
                depressed
                color="primary"
                small
                class="extra-small ma-1"
                @click="onDeleteProduct(product.id)"
                v-if="
                  !(
                    selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret
                  )
                "
              >
                <i class="fa fa-trash middle"></i>
              </v-btn>
              <v-btn
                fab
                depressed
                color="primary"
                small
                class="extra-small ma-1"
                @click="copyProduct"
                v-if="
                  !(
                    selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret
                  )
                "
              >
                <v-icon>content_copy</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div style="padding: 15px; height: 105px; border-bottom: 1px solid #eee">
          <div class="name" :title="product.name">{{ product.name | truncate(20) }}</div>
          <div class="price primary--text title">
            <template v-if="discountPriceRange != priceRange">{{ discountPriceRange }}</template>
            <template v-else>{{ priceRange }}</template>
          </div>
          <div
            class="discount grey--text text--lighten-1 caption"
            v-if="discountPriceRange != priceRange"
          >
            {{ priceRange }}
          </div>
          <div v-else class="discount caption">&nbsp;</div>
          <small
            v-if="
              (selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret) ||
                (product.ref_code && product.ref_code.includes('ZORTOUT'))
            "
            class="name"
            ><span class="primary--text">SKU:</span> {{ product.code }}</small
          >
        </div>
      </div>

      <div style="overflow-y: auto; height: 100px" class="px-2 py-2" v-if="!salePage">
        <template v-if="productstock && productstock.length > 0">
          <stock-item
            :indexProduct="indexProduct"
            :productBy="productBy"
            :refCode="product.ref_code"
            v-for="(stock, sindex) in productstock"
            :key="'stock_' + stock[0]"
            v-model="productstock[sindex]"
            :productId="product.id"
          ></stock-item>
        </template>
        <template v-else>
          <div class="text-xs-center">No stock</div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import StockItem from './StockItem.vue'
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'
import numeral from 'numeral'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['value', 'category', 'selectCategory', 'salePage', 'productBy', 'indexProduct', 'cbAll'],
  data: function() {
    return {
      product: this.value,

      showModal: false,
      showLink: false
    }
  },
  components: { ToggleButton, ModalEditProduct, StockItem, ModalShareLink },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isCheck() {
      return this.cbAll.includes(this.product.id)
    },
    productImages: function() {
      if (this.product.photourl) {
        try {
          return this.product.photourl.split(';;')
        } catch (error) {
          return null
        }
      } else {
        return ''
      }
    },
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'
          case 'GBP':
            return '£'
          default:
            return '$'
        }
      }
      return '$'
    },
    priceRange: function() {
      var min = 0
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.price)
            : parseFloat(this.product.productstock[index][3])
        if (index == 0) {
          min = price
          max = price
        } else {
          if (price > max) {
            max = price
          }
          if (price < min) {
            min = price
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function() {
      var min = 0
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.discountprice) === 0
              ? parseFloat(this.product.price)
              : parseFloat(this.product.discountprice)
            : parseFloat(this.product.productstock[index][3])
        var discountprice =
          this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
            ? price
            : parseFloat(this.product.productstock[index][4])

        if (index == 0) {
          min = discountprice
          max = discountprice
        } else {
          if (discountprice > max) {
            max = discountprice
          }
          if (discountprice < min) {
            min = discountprice
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function() {
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.price)
            : parseFloat(this.product.productstock[index][3])
        var discountprice =
          this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
            ? price
            : parseFloat(this.product.productstock[index][4])

        if (index == 0) {
          max = ((price - discountprice) / price) * 100
        } else {
          var percent = ((price - discountprice) / price) * 100
          if (max < percent) {
            max = percent
          }
        }
      }

      return max
    },
    productstock: function() {
      return this.product.productstock.sort(function(a, b) {
        if (parseInt(a[6]) > parseInt(b[6])) {
          return 1
        } else if (parseInt(a[6]) < parseInt(b[6])) {
          return -1
        } else {
          return 0
        }
      })
    },
    isKetShop() {
      return (
        this.selectedBot.useketshop == true &&
        this.selectedBot.ketshop_api_key &&
        this.selectedBot.ketshop_api_secret
      )
    }
  },
  methods: {
    assignCb(id) {
      this.$emit('assignCb', id)
    },
    async copyProduct() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t(`do_you_want_to_copy`, {
          name: vm.product.name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.postCopy(vm.product.id)
      }
    },
    async postCopy(productId) {
      try {
        const vm = this
        vm.$store.dispatch('loading')
        const response = await vm.post(
          `product/${productId}/duplicate/?pageid=${vm.selectedBot.pageid}`
        )
        if (response.productId) {
          vm.$emit('getAllproduct')

          vm.$swal({
            title: this.$t('Successfully'),
            text: this.$t(`product_has_been_duplicate`, {
              name: vm.product.name
            }),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        } else {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: vm.$t('something_went_wrong'),
            confirmButtonText: vm.$t('Confirm')
          })
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    toggleProductStatus() {
      var vm = this
      vm.$store.dispatch('loading')
      var status = this.product.status
      var data = {
        id: this.product.id,
        status: !status
      }
      api.editProductStatus(data, function(error, response) {
        vm.$store.dispatch('loading')
        if (error) {
          console.error(error)
          return
        }
        vm.$emit('changeproductstatus', data)
      })
    },
    close: async function() {
      let vm = this
      vm.showModal = false
      // $('body').removeClass('modal-open')
      await vm.$nextTick()
      vm.$emit('input', vm.product)
    },
    onDeleteProduct: function(id) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.product.name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteProduct(id, function(error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                console.error(error)
                return
              }

              vm.$emit('productDeleted')
              vm.$emit('close')
              vm.$store.dispatch('loading')
            })
          }
        })
    }
  },
  watch: {
    cbAll(newVal) {
      if (this.cbAll.includes(newVal.id)) this.cb = true
      else this.cb = false
    },
    value: function(newVal, oldVal) {
      if (newVal != oldVal) {
        // this.product = this.value
      }
    },
    showModal: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Product.vue